const safeExec = async (fn, name, onError) => {
  try {
    return await fn();
  } catch (error) {
    onError(`[shell-utilities]: Error while executing ${name}`, {
      error
    });
  }
};
export {
  safeExec
};
